// extracted by mini-css-extract-plugin
export var addButton = "_fx-0";
export var border = "_fx-8";
export var check = "_fx-h";
export var danger = "_fx-6";
export var dropdownContainer = "_fx-1";
export var editModalBody = "_fx-j";
export var footerContainer = "_fx-i";
export var fullWidth = "_fx-a";
export var hide = "_fx-9";
export var icon = "_fx-3";
export var input = "_fx-7";
export var inputFlex = "_fx-b";
export var inputWrapper = "_fx-c";
export var manualFocus = "_fx-5";
export var optionButton = "_fx-4";
export var pillWrapper = "_fx-e";
export var pointer = "_fx-2";
export var showOverflow = "_fx-f";
export var tagsFlex = "_fx-d";
export var xButton = "_fx-g";